module.exports = __webpack_public_path__ + "static/media/tabela.1b68f73c.png";